const shouldMarkPerformance =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    performance && process.env.NODE_ENV === 'development';

export const markPerformance = (markName: string): void => {
    if (shouldMarkPerformance) {
        performance.mark(markName);
    }
};
